import type { OversightAssessmentTestResultsByControlIdResponseRow } from '@risksmart-app/drizzle/src/dto';
import type { GetLatestOversightAssessmentTestResultsByControlIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetLatestOversightAssessmentTestResultsByControlIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetLatestOversightAssessmentTestResultsByControlIdArgs = {
  controlId: string;
};

export const useGetLatestOversightAssessmentTestResultsByControlId =
  createQueryHook<
    UseGetLatestOversightAssessmentTestResultsByControlIdArgs,
    OversightAssessmentTestResultsByControlIdResponseRow[],
    GetLatestOversightAssessmentTestResultsByControlIdQuery
  >({
    trpcQueryOptions: (trpc, { controlId }) =>
      trpc.frontend.testResult.latestOversightAssessmentTestResultsByControlId.queryOptions(
        { controlId }
      ),
    mapTrpcDataToGraphQL: (data) => ({
      control_test_oversight_result: data[0] ? [data[0]] : [],
    }),
    graphqlDocument: GetLatestOversightAssessmentTestResultsByControlIdDocument,
    graphqlVariables: ({ controlId }) => ({ controlId }),
  });
